"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectionPromise = exports.clearLoggedOutRecommender = exports.getLoggedOutRec = exports.loggedOutRecIsValid = exports.EXPERIMENTNAME_OVERRIDE_PREFIX = void 0;
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var LoggerService_1 = require("./LoggerService");
var RecommenderSession_1 = require("./RecommenderSession");
var StatsDClient_1 = require("./StatsDClient");
var RECOMMENDER_WEIGHTS_URL = "https://streamate.icfcdn.com/recommenders/weights.json";
var DEFAULT_LOGGEDOUTREC = "fallback";
var loggedoutSelectionOn = Boolean(localStorage.getItem("loggedoutSelectionOverride"));
var EPSILON_VALUE = 1.0;
exports.EXPERIMENTNAME_OVERRIDE_PREFIX = "override-";
function loggedOutRecIsValid(session) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, continent, isLoggedIn;
        return __generator(this, function (_b) {
            _a = session !== null && session !== void 0 ? session : (0, RecommenderSession_1.getRecommenderSession)(), continent = _a.continent, isLoggedIn = _a.isLoggedIn;
            return [2 /*return*/, (continent === "europe" && !isLoggedIn) || loggedoutSelectionOn];
        });
    });
}
exports.loggedOutRecIsValid = loggedOutRecIsValid;
function getLoggedOutRec() {
    return __awaiter(this, void 0, void 0, function () {
        var session, experimentName, isValid, selection;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    session = (0, RecommenderSession_1.getRecommenderSession)();
                    experimentName = session.experimentName;
                    // strip prefix of "overrride-" if there is any
                    if (experimentName === null || experimentName === void 0 ? void 0 : experimentName.startsWith(exports.EXPERIMENTNAME_OVERRIDE_PREFIX)) {
                        experimentName = experimentName.slice(exports.EXPERIMENTNAME_OVERRIDE_PREFIX.length);
                    }
                    return [4 /*yield*/, loggedOutRecIsValid(session)];
                case 1:
                    isValid = _a.sent();
                    selection = isValid ? experimentName : null;
                    if (!!selection) return [3 /*break*/, 4];
                    if (!isValid) return [3 /*break*/, 3];
                    return [4 /*yield*/, getSelection()];
                case 2:
                    selection = _a.sent();
                    _a.label = 3;
                case 3:
                    selection = selection !== null && selection !== void 0 ? selection : DEFAULT_LOGGEDOUTREC;
                    (0, RecommenderSession_1.updateRecommenderSession)({ experimentName: selection });
                    _a.label = 4;
                case 4: return [2 /*return*/, selection];
            }
        });
    });
}
exports.getLoggedOutRec = getLoggedOutRec;
function clearLoggedOutRecommender() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            (0, RecommenderSession_1.sendRecommenderSessionEvent)("clearLoggedoutSelection");
            (0, RecommenderSession_1.updateRecommenderSession)({ experimentName: "fallback" });
            return [2 /*return*/];
        });
    });
}
exports.clearLoggedOutRecommender = clearLoggedOutRecommender;
// Private API
exports.selectionPromise = null;
function getSelection() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            exports.selectionPromise =
                exports.selectionPromise !== null && exports.selectionPromise !== void 0 ? exports.selectionPromise : getWeights()
                    .then(rollForSelection)
                    .catch(function (err) {
                    LoggerService_1.logger.error("Recommenders - unexpected exception when selecting logedoutrec - falling back", err);
                    return DEFAULT_LOGGEDOUTREC;
                });
            return [2 /*return*/, exports.selectionPromise];
        });
    });
}
function rollForSelection(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var epsilon, experimentName, roll_1, idx;
        var weights = _b.weights, names = _b.names;
        return __generator(this, function (_c) {
            epsilon = Math.random();
            if (epsilon < EPSILON_VALUE) {
                experimentName = names[Math.floor(Math.random() * names.length)];
                experimentName = experimentName ? experimentName : DEFAULT_LOGGEDOUTREC;
                StatsDClient_1.statsd.count("recommenders.experiment-selection-epsilon.".concat(experimentName));
            }
            else {
                roll_1 = Math.random();
                idx = weights.findIndex(function (w) { return w > roll_1; });
                experimentName = idx >= 0 && idx < names.length ? names[idx] : DEFAULT_LOGGEDOUTREC;
            }
            StatsDClient_1.statsd.count("recommenders.experiment-selection.".concat(experimentName));
            (0, RecommenderSession_1.updateRecommenderSession)({ experimentName: experimentName });
            (0, RecommenderSession_1.sendRecommenderSessionEvent)("loggedoutSelection");
            return [2 /*return*/, experimentName];
        });
    });
}
var DEFAULT_BANDIT_WEIGHTS = { names: [], weights: [] };
function getWeights() {
    return __awaiter(this, void 0, void 0, function () {
        function handleException(err) {
            LoggerService_1.logger.error("Recommenders - ".concat(RECOMMENDER_WEIGHTS_URL, " -> cowardly setting model to fallback!"), err);
            StatsDClient_1.statsd.count("recommenders.weights-call.error");
            return DEFAULT_BANDIT_WEIGHTS;
        }
        function processResponse(response) {
            return __awaiter(this, void 0, void 0, function () {
                var data, onlyValid, weights, names, headers, rawModifiedHeader, rawDateHeader, currentDatetime, lastModifiedHeader, age, ttl;
                var _a, _b, _c, _d, _e, _f, _g;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            if (!(response === null || response === void 0 ? void 0 : response.ok)) {
                                throw new Error("Recommenders - ".concat(RECOMMENDER_WEIGHTS_URL, " -> did NOT 200! status=").concat(response.status, " - ").concat(response.statusText));
                            }
                            return [4 /*yield*/, response.json()];
                        case 1:
                            data = _h.sent();
                            onlyValid = function (_, i) { var _a, _b, _c; return ((_a = data === null || data === void 0 ? void 0 : data.modelNames) === null || _a === void 0 ? void 0 : _a[i]) && ((_b = data === null || data === void 0 ? void 0 : data.weights) === null || _b === void 0 ? void 0 : _b[i]) <= 1.0 && ((_c = data === null || data === void 0 ? void 0 : data.weights) === null || _c === void 0 ? void 0 : _c[i]) > 0.0; };
                            weights = Array.from((_a = data === null || data === void 0 ? void 0 : data.weights) !== null && _a !== void 0 ? _a : []).filter(onlyValid);
                            names = Array.from((_b = data === null || data === void 0 ? void 0 : data.modelNames) !== null && _b !== void 0 ? _b : []).filter(onlyValid);
                            if (weights.length !== names.length) {
                                throw new Error("Recommenders - ".concat(RECOMMENDER_WEIGHTS_URL, " -> invalid response weights='").concat(weights, "' names='").concat(names, "'"));
                            }
                            StatsDClient_1.statsd.count("recommenders.weights-call.success");
                            headers = {};
                            ((_c = response === null || response === void 0 ? void 0 : response.headers) === null || _c === void 0 ? void 0 : _c.forEach) &&
                                response.headers.forEach(function (value, key) {
                                    headers[key] = value;
                                });
                            rawModifiedHeader = (_d = headers === null || headers === void 0 ? void 0 : headers["last-modified"]) !== null && _d !== void 0 ? _d : "'";
                            rawDateHeader = (_e = headers === null || headers === void 0 ? void 0 : headers["date"]) !== null && _e !== void 0 ? _e : "";
                            currentDatetime = Date.parse(rawDateHeader);
                            lastModifiedHeader = Date.parse(rawModifiedHeader);
                            age = parseInt((_f = headers === null || headers === void 0 ? void 0 : headers["cf4age"]) !== null && _f !== void 0 ? _f : "0");
                            ttl = parseInt((_g = headers === null || headers === void 0 ? void 0 : headers["cf4ttl"]) !== null && _g !== void 0 ? _g : "0");
                            if (currentDatetime && lastModifiedHeader && lastModifiedHeader - currentDatetime > 3 * 60 * 60 * 1000) {
                                StatsDClient_1.statsd.count("recommenders.cdn.pastExpiration");
                                LoggerService_1.logger.warn("Recommenders - ".concat(RECOMMENDER_WEIGHTS_URL, " -> unexpected old last modified header: lastModified=").concat(rawModifiedHeader, " date=").concat(rawDateHeader));
                            }
                            if (age) {
                                StatsDClient_1.statsd.timing("recommenders.cdn.cf4age", age);
                            }
                            if (ttl) {
                                StatsDClient_1.statsd.timing("recommenders.cdn.cf4ttl", ttl);
                            }
                            return [2 /*return*/, { weights: weights, names: names }];
                    }
                });
            });
        }
        return __generator(this, function (_a) {
            return [2 /*return*/, fetch(RECOMMENDER_WEIGHTS_URL, {
                    signal: AbortSignal.timeout(500),
                })
                    .then(processResponse)
                    .catch(handleException)];
        });
    });
}
//# sourceMappingURL=RecommenderBandit.js.map